import { useEffect, useState } from 'react';

const Footer = () => {
  const [logo, setLogo] = useState([]);

      useEffect(() => {
          const fetchPromotions = async () => {
              try {
                  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
                  if (!response.ok) {
                      throw new Error("Failed to fetch promotions");
                  }
                  const data = await response.json();
                  setLogo(data[0].logo);
              } catch (error) {
                  console.error("Error fetching promotions:", error);
              }
          };
  
          fetchPromotions();
      }, []);
      const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net)$/i, '');
      // Full domain origin (e.g. stk111.com) - no hardcoded TLD suffix
      const fullDomain = (window.location.hostname || '').replace(/^www\./, '');


  return (
    <footer className="dk-footer">
      <div className="dk-footer-container">

        {/* Top Section */}
        <div className="dk-footer-top">

          {/* Left Column */}
          <div className="dk-footer-col">
            <div className="dk-footer-brand">
              <div className="footer-logo"><img className="common-logo" src={`${process.env.REACT_APP_API_URL}/storage/${logo}`} alt="Logo" /></div>
              <span className="dk-footer-age">18+</span>
            </div>

            <p className="dk-footer-text">
              এই ওয়েবসাইটে থাকা হ্যান্ডিক্যাপ এবং স্পোর্টস অডস তথ্য শুধুমাত্র বিনোদনের উদ্দেশ্যে।
              অনুগ্রহ করে আপনার এলাকায় প্রচলিত বাজি নিয়মাবলী পরীক্ষা করুন কারণ সেগুলি রাজ্য থেকে রাজ্য,
              প্রদেশ থেকে প্রদেশ এবং দেশ থেকে দেশ ভিন্ন হতে পারে। এই তথ্যটি কোনও আইন বা বিধি লঙ্ঘন করতে
              ব্যবহার করা নিষিদ্ধ।
            </p>

            <p className="dk-footer-text">
              সাইটটি কোন পেশাদার বা কলেজিয়েট লীগ, অ্যাসোসিয়েশন বা টিমের সাথে সংযুক্ত বা অনুমোদিত নয়।
              {origin} ১৮ বছরের নিচে কাউকে লক্ষ্য করে না।
            </p>
          </div>

          {/* Middle Column */}
          <div className="dk-footer-col">
            <h3 className="dk-footer-title">দায়িত্বশীল গেমিং</h3>
            <ol className="dk-footer-list">
              <li>এই পণ্যটি আঠারো বছরের উপরে ব্যবহারকারীদের জন্য এবং শুধুমাত্র বিনোদনের উদ্দেশ্যে।</li>
              <li>এই গেমে ইন-অ্যাপ ক্রয় রয়েছে।</li>
              <li>
                একটি খেলোয়াড় যদি সামাজিক বাজি খেলায় খেলেন বা জিতেন,
                তবে এর মানে এই নয় যে আপনি ভবিষ্যতে বাস্তব অর্থের বাজি এবং সম্পর্কিত গেমে জিতবেন।
              </li>
            </ol>
          </div>

          {/* Right Column */}
          <div className="dk-footer-col">
            <h3 className="dk-footer-title">অপারেটর ও লাইসেন্স</h3>
            <p className="dk-footer-text">
              {fullDomain} সাইটটি ব্রিলিয়ান্ট স্টার সার্ভিসে বি.ভি. ( নিবন্ধিত নং ১৫৯৯৮২) দ্বারা পরিচালিত হয়,
              যার ঠিকানা হলো জুলিয়ানাপ্লেইন ৩৬, কুরাসাও।
            </p>
            <p className="dk-footer-text">
              এই ওয়েবসাইটটি লাইসেন্স নম্বর: ৮০৪৮/জেএজেড এর অধীনে পরিচালিত হয় যা গেমিং সার্ভিস প্রোভাইডার
              দ্বারা করা হয়েছে এবং কুরসাও সরকারের দ্বারা অনুমোদিত ও নিয়ন্ত্রিত।
            </p>
            <p className="dk-footer-text">
              Bstar Service LTD, নিবন্ধন নম্বর HE 430899
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="dk-footer-bottom">
          <div className="dk-footer-bottom-left">
            © <span>{fullDomain}</span> — All Rights Reserved.
          </div>

          <div className="dk-footer-bottom-right">
            <a href="#" className="dk-footer-link">Terms &amp; Conditions</a>
            <span className="dk-footer-separator">|</span>
            <a href="#" className="dk-footer-link">Privacy Policy</a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
